import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type createFileElementButton_CreateFileElementMutation } from "@relay/createFileElementButton_CreateFileElementMutation.graphql";
import { CREATE_FILE_ELEMENT_MUTATION } from "./create-file-element-button.graphql";
import { type CreateFileElementButtonProps } from "./create-file-element-button.types";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const CreateFileElementButton = ({
	eLearningContentNodeId,
}: CreateFileElementButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createFileElement, isCreatingTextElement] =
		useMutation<createFileElementButton_CreateFileElementMutation>(
			CREATE_FILE_ELEMENT_MUTATION,
		);

	return (
		<Button
			disabled={isCreatingTextElement}
			tooltip={t("educationalOffer.createFileElementTooltip")}
			icon={EpicIcons.FILE}
			onClick={() => {
				createFileElement({
					variables: {
						input: {
							eLearningContentNodeId,
							title: t("educationalOffer.newElement"),
							fileId: undefined,
						},
					},
					updater: setDraft,
				});
			}}
		/>
	);
};
